import React from 'react';
import axios from 'axios';
import Form from './Common/Form';
import {connect} from 'react-redux';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import * as actions from '../actions/GlobalActions';
import { Alert } from 'react-bootstrap/lib/';

class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      loading : false,
      msg : null,
      changePasswordMsg : null,
      username : "",
      password : "",
      remember : false,
      screenID : 0, //0 -> normal login, 1 -> send pw reset, 2 -> change pw
      resetUsername : "",
      changePassword1 : "",
      changePassword2 : "",
      loginForm: null,
      query_params: null,
    };

    this.handleLoginButton = this.handleLoginButton.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
  }

  componentDidMount () {

    this.fetchLoginForm();
  }

  fetchLoginForm() {
          const searchParams = new URLSearchParams(window.location.search);
          let params = {};

          ['response_type','client_id','redirect_uri','state','user_id','tid','client_name','token'].forEach(param => {
                  if ( searchParams.get(param)) {
                          params[param] = searchParams.get(param);
                  }
          });
          const keys = Object.keys(params);
          let query_params = window.location.search;
          keys.forEach(key => { query_params += `${key}=${params[key]}&` });
          query_params = query_params.replace(/&$/,'');

          const uid_param = params['user_id'] ? `?uid=${params['user_id']}` : '';

          const url = process.env.API_URL + '/auth/login' + uid_param;

          if (params['token']) {
                  // Attempt auto login
                  if (params['user_id']) params['username'] = params['user_id'];
                  this.props.actions.login(params,'')
                          .then(function(response) {
                                  // console.log(response);
                                  if(response.success) {
                                          if(response.force_pw_change == true) {
                                                  this.setState({
                                                          screenID : 2,
                                                          loading : false
                                                  });
                                          } else if (response.user_type === "timeclock") {
                                                  browserHistory.push('timeclock');
                                          } else {
                                                  browserHistory.push('dashboard');
                                          }
                                          return;
                                  } else {
                                          this.setState({
                                                  msg : "Invalid credentials",
                                                  loading : false
                                          })
                                  }
                          })
          }
          return axios.request({
                  url: url,
                  headers: {'Content-Type': 'application/json'},
                  method: 'GET',
          })
                  .then(response => {
                          /* This redirect to HTTPS is a temporary solution to a Problem in the Server. */
                          if(response && response.data && response.data.production && location.protocol != 'https:'){
                                  location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
                          }else {
                                  response.data && this.setState({loginForm: response.data,query_params: query_params})
                                  browserHistory.push('/login');
                          }
                  })
    .catch(err => {
      console.log('Fetching login form failed:');
      console.log(err);
      throw err;
    });
  }

  handleLoginButton(params) {
    this.props.actions.login(params,this.state.query_params)
    .then(function(response) {
      if(response.success) {
        if(response.force_pw_change == true) {
          this.setState({
            screenID : 2,
            loading : false
          });
        } else if (response.redirect_to) {
					location.href = response.redirect_to;
        } else if (response.user_type === "timeclock") {
          browserHistory.push('timeclock');
        } else {
          browserHistory.push('dashboard');
        }
      } else {
        this.setState({
          msg : "Invalid credentials",
          loading : false
        })
      }
    })
    .catch(err => {
      console.log('dat err:', err);
      if(err.response && err.response.data && err.response.data.errmsg){
        this.setState({
          msg : err.response.data.errmsg,
          loading : false,
        });
      }else {//In case there's no err.response.data.errmsg
        this.setState({
          msg : err.message,
          loading : false,
        });
      }
    })
  }

  handleResetButton(e) {
    e.preventDefault();
    this.props.actions.submitPasswordReset({
      email : this.state.resetUsername
    })
    .then(response => {
      if(response.success) {
        this.setState({
          msg : "Password reset email sent. Check your email and click the link to reset your password.",
          screenID : 0
        })
      }
    });
  }

  handleChangePassword(e) {
    e.preventDefault();
    this.props.actions.submitChangePassword({
      old_password : this.state.password,
      new_password : this.state.changePassword1,
      confirm_password : this.state.changePassword2
    })
    .then(response => {
      // console.log(response);
      if(response.success == 1) {
        browserHistory.push('dashboard');
      } else {
        this.setState({
          changePasswordMsg : response.msg
        });
      }
    });
  }

  showScreenByID(id) {
    this.setState({
      screenID : id
    });
  }

  handleInputChange(event) {
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

    let s = this.state;
    s[name] = value;

    this.setState({
      s
    });
  }

  render() {
    if(this.state.loginForm){
      return (
        <div className="login">
        {this.state.msg && (
          <div style={{maxWidth:'300px', marginRight:'auto', marginLeft:'auto'}}>
            <Alert bsStyle="warning">{this.state.msg}</Alert>
          </div>
        )}
        {this.state && this.state.screenID == 0 && (
          <Form
            standAlone={true}
            formData={this.state.loginForm.config}
            handleLoginButton={this.handleLoginButton}
            extraStyle={{minWidth: '300px',textAlign:'left'}}
          />
        )}
        </div>
      );
    }else {
      return <div className="login" />;
    }
  }
}

function mapStateToProps(state) {
  // console.log('state to props');
  // console.log(state);
  return {
    isLoggedIn: state.loggedIn,
    redirectUrl: state.redirectUrl
  }
}

function mapDispatchToProps(dispatch) {
  // console.log('mappin dispatch to props in login');
  // console.log(dispatch);
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/components/Login.js